function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

/**
 * Helper component for the Touchable component with no opacity feedback.
 *
 * Applies recommended hitSlop by default.
 * @see https://reactnative.dev/docs/view#hitslop
 *
 * Allows passing ReactNode as children whereas original TouchableWithoutFeedback not.
 */
export class TouchableWithoutFeedback extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "createHitSlopInsets", () => {
      const flatStyle = StyleSheet.flatten(this.props.style || {}); // @ts-ignore: `width` is restricted to be a number

      const value = 40 - flatStyle.height || 0;
      return {
        left: value,
        top: value,
        right: value,
        bottom: value
      };
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      activeOpacity: 1.0,
      hitSlop: this.props.useDefaultHitSlop && this.createHitSlopInsets()
    }, this.props));
  }

}